export default class EditorColorGradient {
    constructor(data) {
        this.type = `linear`;
        this.angle = 0;
        this.stops = [
            { color: `#ffffff`, position: 0 },
            { color: `#000000`, position: 100 }
        ];

        if (data) {
            this.loadStyle(data);
        }
    }

    toCss() {
        if (!this.stops || this.stops.length < 2) {
            return `#ffffff`;
        }

        const sortedStops = [...this.stops]
            .sort((a, b) => a.position - b.position);

        const stops = sortedStops
            .map(stop => {
                let color = stop.color;
                if (color && !color.startsWith(`#`) && !color.startsWith(`rgb`) && !color.startsWith(`hsl`) && !color.startsWith(`var(`)) {
                    color = `var(--${color}-color)`;
                }
                return `${color} ${Math.round(stop.position)}%`;
            })
            .join(`, `);

        if (this.type === `linear`) {
            return `linear-gradient(${this.angle || 0}deg, ${stops})`;
        }

        return `#ffffff`;
    }

    loadStyle(data) {
        if (typeof data === `string`) {
            this.type = `linear`;
            this.angle = 0;
            this.stops = [
                { color: `#ffffff00`, position: 0 },
                { color: data, position: 100 }
            ]
        } else if (typeof data === `object` && data !== null) {
            this.type = data.type || `linear`;
            this.angle = data.angle || 0;
            this.stops = data.stops && Array.isArray(data.stops) && data.stops.length > 0
                ? [...data.stops]
                : [
                    { color: `#ffffff`, position: 0 },
                    { color: `#000000`, position: 100 }
                ];
        }
    }

    toJSON() {
        return {
            type: this.type,
            angle: this.angle,
            stops: [...this.stops]
        };
    }
}
